<div style="vertical-align: middle; text-align: center;">
    <h1>Anmeldung abgelaufen</h1>
<p>Bitte erneut anmelden!</p>
<lib-unauthorized></lib-unauthorized>   
</div>